import React, { Component } from 'react';
import Switch from "react-switch";
import Select from 'react-select';

import { Popover, OverlayTrigger, Table } from "react-bootstrap";
import { toast } from 'react-toastify';
import CustomModal from "../../components/Modal/CustomModal";

import { consultaMatInscritaDir, verEstudianesInsc } from '../../funciones/InscripcionFunction';
import { CheckMateria } from '../../funciones/EstudiantesFunction';


class InscripcionTableDir extends Component {
    state = {
        check: false,
        preloader: "fa fa-circle-o",
        tr: [],
        materias:this.props.materiasS,
        uc: 0,
        valorTipo: { value: '0', label: '- CARGANDO -' },
        selectDisabled: false,
        boton1Modal:<React.Fragment><i className="fa fa-check"></i> Si</React.Fragment>,
        boton2Modal:<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>,
        openW: false,
        tituloModal: "Advertencia",
        contenidoModal: <div>
                            <div>Este estudiante <strong>Posee Calificaciones</strong> en esta materia. ¿Deseas quitarla?</div>
                            <div style={{fontSize: 10}}>Si presionas <strong>Si</strong> al Guardar perderás las calificaciones del estudiante en esta materia</div>
                        </div>,
        tipos: [],
    }

    constructor (props) {
        super (props);
        let { opciones } = this.props;
        setTimeout(() => {
            consultaMatInscritaDir (this.props.opciones.seccionId, this.props.idEst, (resp) => {
                this.setState({
                    selectDisabled: resp[0],
                    check: resp[0],
                    uc: resp[1],
                    valorTipo: resp[3],
                    openW: false,
                    tipos: resp[4]
                }, () => {
                    /* if (resp[0] === true && resp[2] === 1) this.props.add(opciones.materiaId, opciones.seccionId, this.state.uc)
                    if (resp[0] === false && resp[2] === 1) this.props.del(opciones.materiaId, opciones.seccionId, this.state.uc) */
                })
            })
        }, this.props.sec);
    }

    cambiaTipo = (valorTipo) => {
        this.setState({
            valorTipo,
            openW: false,
        })
    }

    componentWillReceiveProps = () => {
        this.setState({
            openW: false
        })
    }

    funcion1 = () => {
        let { opciones } = this.props;
        let Sec= {id: opciones.seccionId, tipo: this.state.valorTipo.value}
        this.setState({
            selectDisabled: false,
            check: false,
            openW: false,
        }, () => {
            this.props.del(opciones.materiaId, Sec, this.state.uc)
        }) 
    }

    showModal = () => {
        const { openW, tituloModal, contenidoModal, boton1Modal, boton2Modal } = this.state;
        return (
            <CustomModal
                isopen =  {openW}
                backgroundColor = "#ebf2f2"
                titulo = {<div style={{color:"#1f2f6e"}}>{tituloModal}</div>}
                contenido = {contenidoModal}
                boton1 = {boton1Modal}
                boton2 = {boton2Modal}
                funcion1 = {this.funcion1}/>
        );
    }

    cambiacheck= (materia, seccion) => (e) => {

        let Sec= {id: seccion, tipo: this.state.valorTipo.value}
        let estadoCheck = this.state.check
        if(estadoCheck === false) {
            let cantidad = 1;
            let data = this.props.materiasS
            let check = true;
            
            for (let i in data) {
                if(data[i] === materia) cantidad ++;
            }

            if (this.props.opciones.cupos <= 0){
                check = false
                    toast.error("No puedes seleccionar esta materia porque no posee cupos disponibles en esta sección",{autoClose: 4000});
                    this.setState({
                        check: check,
                })
            }else{
                if (cantidad > 1){
                    check = false
                    toast.error("No puedes seleccionar materias duplicadas aunque estén en distinta sección",{autoClose: 4000});
                    this.setState({
                        check: check,
                        openW: false,
                    })
                }else{
                    this.setState({
                        selectDisabled: true,
                        check: check,
                        openW: false,
                    }, () => {
                        this.props.add(materia, Sec, this.state.uc)
                    })
                }
            }
        }else{
            /* Revisar si el estudiante posee calificaciones en la materia */
            CheckMateria (seccion, this.props.idEst, (resp)=> {
                if(resp.status === true) {
                    this.setState({
                        openW: true,
                    })
                }else{
                    this.setState({
                        selectDisabled: false,
                        check: false,
                        openW: false,
                    }, () => {
                        this.props.del(materia, Sec, this.state.uc) 
                    }) 
                }
            })
        }

    }

    verEstudiantes = (id) => (e) => {
        verEstudianesInsc(id, (resp) => {
            this.setState({
                tr: resp,
                openW: false,
            })
        })
    }

    estudiantes = () => {
        let { tr } = this.state;
        if (tr.length === 0) return (
            <tr align="center" style={{fontSize:12}}>
                <td style={{fontSize:10}}> Ninguno </td>
            </tr>
        )
        return(
            tr.map(option => (
                <tr key={option.ci}>
                    <td style={{fontSize:10}}>{`${option.nombre1} ${option.nombre2} ${option.apellido1} ${option.apellido2}`}</td>
                </tr>
            ))
        )
    }

    render() {
        let { opciones } = this.props;
        let { check, valorTipo, selectDisabled, tipos } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let infoSeccion = (
            <Popover bsSize="large" title="Información Adicional de la Sección" id="infoSeccion">
                <div style={{fontSize: 10}}>Profesor: <strong className="text-primary">{opciones.prof}</strong></div>
                <div style={{fontSize: 10}}>Aula: <strong className="text-primary">{opciones.aula}</strong></div>
                <div className="table-responsive custom-mt-10" style={{ overflowY :"auto", height:"45vh",}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td style={styles}><strong>Estudiantes Inscritos</strong></td>
                            </tr>
                            {this.estudiantes(opciones.seccionId)}
                        </tbody>
                    </Table>
                </div>
            </Popover>
        )

        const customStyles = (base) => ({
            ...base,
            fontSize: 12,
        });

        return (
            <React.Fragment>
            <tr>
                <td style={styles}><strong>{opciones.materia}</strong></td>
                <td align="center" style={styles}>{opciones.seccion}</td>
                <td align="center" style={styles}>{opciones.cupos}</td>
                <td align="center" style={styles}>{this.state.uc}</td>
                <td align="center" style={styles}>
                    <Select
                        styles={{menu: customStyles}}
                        isSearchable ={true}
                        value={valorTipo}
                        onChange={this.cambiaTipo}
                        options={tipos}
                        isDisabled = {selectDisabled}
                    />
                </td>
                <td align="center" style={styles}>
                    <OverlayTrigger trigger="focus" placement="left" overlay={infoSeccion}>
                        <button onClick={this.verEstudiantes(opciones.seccionId)} style={{borderWidth: 1}} className="btn btn-relleno-primary btn-sm" title="Ver más información de la sección"><i className="fa fa-question-circle-o"></i></button>
                    </OverlayTrigger>
                </td>
                <td align="center" style={styles} title= "Seleccionar Materia">
                    <Switch height={12} width={24} onChange={this.cambiacheck(opciones.materiaId, opciones.seccionId)} checked={check} />
                </td>
            </tr>
            {this.showModal()}
            </React.Fragment>
        );
    }
}
 
export default InscripcionTableDir;



// WEBPACK FOOTER //
// ./src/views/Inscripcion/InscripcionTableDir.jsx